import React, { Fragment, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import styled from '@emotion/styled';

import StockBlock from '../common/StockBlock';

import InputWrapper from '../../common/InputWrapper';
import Select from '../../common/Select';
import Button from '../../common/Button';
import Checkbox from '../../common/Checkbox';

import { checkIfProductHasVariants, getEshopType } from '../../../helpers';
import { PRODUCT_TYPES } from '../../../config';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  padding: 1.5rem 0;
  > div:not(.border-block) {
    margin-left: calc(1.5rem - 12px);
    margin-right: calc(1.5rem - 12px);
  }
  .border-block {
    border-top: 1px solid #f7f6f6;
  }
  .product-id-top {
    position: relative;
  }
  .product-id {
    cursor: pointer;
    border-bottom: 1px dashed #72747b;
  }
  .help-tooltip {
    min-width: 0;
    right: 0;
    left: unset;
    cursor: text;
    white-space: nowrap;
  }

  .add-barcode-dropdown-shadow {
    position: fixed;
    opacity: 0.2;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .form-group {
    position: relative;
  }

  .options-list {
    position: absolute;
    top: 27px;
    right: 0;
    background: white;
    z-index: 1;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 5px;
    list-style: none;
    width: 180px;

    .options-item {
      padding: 9px 19px;
      cursor: pointer;

      &:hover {
        background: #7e57c310;
      }
    }
  }

  .barcode-type-info {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    margin: auto;
    height: fit-content;
    color: #7e57c2;
    pointer-events: none;
  }

  .barcode-type-info-first {
    top: 27px;
  }

  .weight-group {
    .react-select__control {
      width: 70px;
      height: 36px;
    }
  }
`;

const weightTypes = [
  { value: 'kg', label: 'кг' },
  { value: 'gr', label: 'гр' },
];

const AdAttachmentsParametersBlock = (props) => {
  const { values, errors, handleChangeInput, handleChangeWeightType } = props;

  const { t } = useAutoTranslation();

  return (
    <div className="col-lg-6">
      <Wrapper className="card-box">
        <div className="row">
          <div className="col-12">
            <h4 className="header-title">{t('Свойства')}</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="form-group mb-4">
              <Select
                label={t('Тип продукта')}
                id="type"
                options={PRODUCT_TYPES}
                value={PRODUCT_TYPES.find((o) => o.value === values.type)}
                onChange={({ value }) => handleChangeInput('type', value)}
              />
            </div>
          </div>
        </div>

        <div className="row d-flex justify-content-between">
          <div className="col-md-4">
            <h4 className="header-title">{t('Параметры')}</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="form-group weight-group">
              <InputWrapper
                type="text"
                label={t('Вес')}
                id="weight"
                value={values.weight}
                error={errors.weight}
                onChange={(e) => handleChangeInput('weight', e.target.value)}
                textAppend={
                  <Select
                    options={weightTypes}
                    value={weightTypes.find((t) => t.value === values.weightType) || undefined}
                    onChange={(e) => handleChangeWeightType(e.value)}
                    isDisabled={values.autoDimensionsCalculation}
                  />
                }
                placeholder={t('Введите вес')}
                readOnly={values.autoDimensionsCalculation}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-4 col-md-4 col-lg-12 col-xl-4">
            <div className="form-group">
              <InputWrapper
                type="number"
                label={t('Ширина')}
                id="width"
                value={values.width}
                error={errors.width}
                onChange={(e) => handleChangeInput('width', e.target.value)}
                textAppend={t('см')}
                showValidation
                readOnly={values.autoDimensionsCalculation}
              />
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-12 col-xl-4">
            <div className="form-group">
              <InputWrapper
                type="number"
                label={t('Высота')}
                id="height"
                value={values.height}
                error={errors.height}
                onChange={(e) => handleChangeInput('height', e.target.value)}
                textAppend={t('см')}
                showValidation
                readOnly={values.autoDimensionsCalculation}
              />
            </div>
          </div>
          <div className="col-sm-4 col-md-4 col-lg-12 col-xl-4">
            <div className="form-group">
              <InputWrapper
                type="number"
                label={t('Глубина')}
                id="depth"
                value={values.depth}
                error={errors.depth}
                onChange={(e) => handleChangeInput('depth', e.target.value)}
                textAppend={t('см')}
                showValidation
                readOnly={values.autoDimensionsCalculation}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default AdAttachmentsParametersBlock;
